import {Directive, ElementRef, Input, OnInit} from '@angular/core';

export type svgSize = 1 | 2 | 3 | 4;

@Directive({
  selector: '[appSvg]',
  standalone: true,
})
export class SvgDirective implements OnInit {

  constructor(private elementRef: ElementRef<HTMLInputElement>) {

  }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.height = '1em';
    this.elementRef.nativeElement.style.width = '1em';
  }

  @Input()
  set appSvg(given: svgSize){
      const size = this.calculateSize(given || 1);
      this.elementRef.nativeElement.style.fontSize = size;
  }

  calculateSize(size: svgSize): string{
      const multiple: number = size as number;
      return this.convertToCorrectBase(multiple);
  }

  convertToCorrectBase(size: number): string{
    return size + 'em';
  }
}
